import CertsSidePanelAccounts from './CertsSidePanelAccounts';

export default CertsSidePanelAccounts;
